module.exports = __webpack_public_path__ + "static/media/product_24.6e54de52.png";